import React from 'react';
import Chevron from '../../assets/icons/chevron';
import { Button, LinkButton, Header } from './styles';

export default function BackToHomePageButton() {
  return (
    <Header>
      <LinkButton to="/">
        <Button>
          <Chevron />
        </Button>
        Página inicial
      </LinkButton>
    </Header>
  );
}
